import { render, staticRenderFns } from "./NationalChildDetail.vue?vue&type=template&id=34f08b92&scoped=true"
var script = {}
import style0 from "./NationalChildDetail.vue?vue&type=style&index=0&id=34f08b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f08b92",
  null
  
)

export default component.exports